import { joinUrl } from '@libs/core';

import { getOrigin } from './getOrigin';

export const joinOriginUrl = (path: RequestInfo | URL, headers?: Headers) => {
    const origin = getOrigin(headers);

    return joinUrl(process.env.NEXT_PUBLIC_CUSTOM_ORIGIN_URL ?? origin, path);
};
